<template>
  <div class="user-dropdown">
    <div class="user-button">
      <span class="d-none d-sm-block"> {{ user.nome }} </span>
      <div class="user-dropdown-img">
        <!-- <Gravatar :cpf="user.foto_url" alt="User" /> -->
        <b-avatar :src="user.foto_url" size="3rem"></b-avatar>
      </div>
      <i class="fa fa-angle-down"></i>
    </div>
    <div class="user-dropdown-content">
      <!-- 
                <router-link to="/admin" v-if="user.admin">
                    <i class="fa fa-cogs"></i> Administração
                </router-link>
                -->

      <a href="#" v-b-modal.modal-center
        ><i class="fa fa-key"></i> Alterar senha</a
      >
      <a href @click.prevent="logout"><i class="fa fa-sign-out"></i> Sair</a>
    </div>

    <div>
      <!--      <b-button v-b-modal.modal-center>Launch centered modal</b-button>   -->

      <b-modal
        id="modal-center"
        centered
        title="Alteração de senha"
        cancel-title="Fechar"
        @ok="putSenha()"
        ok-title="Gravar"
        no-close-on-esc
        no-close-on-backdrop
      >
        <div>
          <b-form-group
            label="Digite sua nova senha"
            label-for="input-formatter"
            class="mb-0"
          >
            <b-form-input
              id="input-formatter"
              v-model="user.password"
              placeholder="digite aqui"
              type="password"
              :formatter="formatter"
            ></b-form-input>
          </b-form-group>

          <b-form-group label="Repita a sua nova senha" class="mb-0">
            <b-form-input
              id="input-lazy"
              v-model="user.confirmPassword"
              placeholder="digite aqui"
              type="password"
              lazy-formatter
              :formatter="formatter"
            ></b-form-input>
          </b-form-group>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
//import { baseApiUrl } from '@/global'
import { baseApiUrl, showError } from "@/global";
import axios from "axios";
import { userKey } from "@/global";
import { mapState } from "vuex";
//import axios from 'axios'
import Gravatar from "vue-gravatar";

export default {
  name: "UserDropdown",

  data: function () {
    return {};
  },

  components: { Gravatar },
  computed: mapState(["user"]),
  methods: {
    // Método formatter adicionado para resolver o warning
    formatter(value) {
      // Este formatter simplesmente retorna o valor como está.
      // Você pode adicionar lógica de formatação aqui se precisar.
      return value;
    },
    logout() {
      localStorage.removeItem(userKey);
      this.$store.commit("setUser", null);
      this.$router.push({ name: "auth" });
    },
    /*

        putSenha() {          
            const id = this.user.id 
            axios.put(`${baseApiUrl}/users/pw${id}`, this.user)
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.reset()
                })
                .catch(showError)
        },
        */

    putSenha() {
      let corpo = {
        id: `${this.user.id}`,
        password: `${this.user.password}`,
        confirmPassword: `${this.user.confirmPassword}`,
      };

      const url = `${baseApiUrl}/users/pw/`;

      axios
        .post(url, corpo)
        .then(() => {
          this.$toasted.global.defaultSuccess();
          this.reset(); // limpar os objetos valores
        })
        .catch(showError);
    },

    reset() {
      (this.user.password = ""), (this.user.confirmPassword = "");
    },
  },
};
</script>

<style>
.user-dropdown {
  position: relative;
  height: 100%;
}

.user-button {
  display: flex;
  align-items: center;
  color: #fff;
  font-weight: 100;
  height: 100%;
  padding: 0px 20px;
}

.user-dropdown:hover {
  background-color: rgba(0, 0, 0, 0.2);
}

.user-dropdown-img {
  margin: 0px 10px;
}

.user-dropdown-img > img {
  max-height: 37px;
  border-radius: 5px;
}
.user-dropdown-content {
  position: absolute;
  right: 0px;
  background-color: #f9f9f9;
  min-width: 170px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  padding: 10px;
  z-index: 1;

  display: flex;
  flex-direction: column;
  flex-wrap: wrap;

  visibility: hidden;
  opacity: 0;
  transition: visibility 0s, opacity 0.5s linear;
}

.user-dropdown:hover .user-dropdown-content {
  visibility: visible;
  opacity: 1;
}

.user-dropdown-content a {
  text-decoration: none;
  color: #000;
  padding: 10px;
}

.user-dropdown-content a:hover {
  background-color: #ededed;
  text-decoration: none;
}
</style>
